import { call, put, takeLatest, select } from 'redux-saga/effects';
import { captureException } from '../../../client/sentry';
import { graphql } from '../../../globals/api/requests';
import {
  createListError,
  createListSuccess,
  openLists,
  selectList,
  addListItemSuccess,
  addListItemError,
  ADD_LIST_ITEM_REQUEST,
  CREATE_LIST_REQUEST,
  CREATE_LIST_SUCCESS,
} from '../actions/lists';

import { setMobileSidebarView } from '../components/sidebar-mobile/actions';
import { VIEWS } from '../components/sidebar-mobile/constants';
import mobileMenuActions from '../../navigation/actions/mobile-menu';

import { promptToast } from '../../../components/toast-container/actions';
import { SIDEBAR_STATE } from '../constants';

import updateUser from './update-user';

export function* createList({ listName }) {
  let createdList;

  try {
    const response = yield call(
      graphql,
      `mutation listCreate($name: String!) {
          listCreate(name: $name) {
            success
            list {
              id
              name
            }
          }
        }`,
      {
        name: listName,
      }
    );

    if (response.errors) {
      yield put(createListError(response.errors[0]));
      return false;
    }

    createdList = response.data.listCreate.list;

    yield put(createListSuccess(createdList));
  } catch (error) {
    yield put(createListError(error));
    return false;
  }

  return createdList;
}

export function* addListItem({ product, isDesktop }) {
  const { tab } = yield select(state => state.areas.sidebar);

  if (!isDesktop) {
    yield put(mobileMenuActions.openMenu());
    yield put(setMobileSidebarView(VIEWS.LIST));
  }

  if (tab !== SIDEBAR_STATE.LISTS) {
    yield put(openLists());
  }

  const { selectedList } = yield select(state => state.areas.sidebar);
  const { nodes: lists } = yield select(state => state.areas.account.me.lists);

  let listId = selectedList;
  let listName = selectedList
    ? lists.find(x => x.id === listId).name
    : undefined;

  if (!listId) {
    const createdList = yield call(createList, {
      listName: window.APP_GLOBALS.t('lists', 'list.default-name'),
    });
    listId = createdList.id;
    listName = createList.name;

    yield put(selectList(listId));
  }

  try {
    const response = yield call(
      graphql,
      `
      mutation listItemAdd($id: ID!, $listId: Int!, $type: ListItemType!) {
        listItemAdd(id: $id, listId: $listId, type: $type) {
          success
          item {
            id
          }
        }
      }`,
      {
        id: product.id,
        listId,
        type: 'product',
      }
    );

    if (response.errors) {
      yield put(addListItemError(response.errors[0]));
    }

    yield put(
      addListItemSuccess(response.data.listItemAdd.item.id, listId, product)
    );

    yield put(
      promptToast(
        'success',
        window.APP_GLOBALS.t('lists', 'confirm.item-added', {
          productName: product.name,
          listName,
        })
      )
    );
  } catch (err) {
    yield call(captureException, err);
    yield put(addListItemError(err));
  }
}

function* mySaga() {
  yield takeLatest(ADD_LIST_ITEM_REQUEST, addListItem);
  yield takeLatest(CREATE_LIST_REQUEST, createList);
  yield takeLatest(CREATE_LIST_SUCCESS, updateUser);
}

export default mySaga;
